
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import NotFoundPage from './pages/404';
import MyAccount from './pages/MyAccount';
import Checkout from './pages/Checkout';
import About from './pages/About';
import PostCheckout from './pages/PostCheckout';
import Login from './pages/Signup';
import './App.css'; // Import your CSS file here


function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/plans" element={<Checkout />} />
          <Route path="/my-account" element={<MyAccount />} />
          <Route path="/thankyou" element={<PostCheckout />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} /> */}
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
